import { FormOffer } from './form-product';
import { Offer } from './product';

export enum WizardStep {
	HEADER = 0, PROD_SPEC = 1, CART = 2, REVIEW = 3, CONFIRMATION = 4
}

class AppWizardStateOffer {
	readonly form = new FormOffer();
	readonly lastSavedOffer: Offer;

	constructor(offer: Offer, lastSavedOffer: Offer) {
		this.form = new FormOffer();
		this.form.setOffer(offer);
		this.lastSavedOffer = lastSavedOffer;
	}
}

class AppWizardStateUi {
	adycoFields?: string[];
	defaultFields?: string[];
	private newTemplateProduct = true;

	isNewTemplateProduct() {
		return this.newTemplateProduct;
	}

	setNewTemplateProduct(newTemplateProduct: boolean) {
		this.newTemplateProduct = newTemplateProduct;
	}
}

export class AppWizardState {
	// state remains valid during the wizard session
	// wizard session starts when following actions are made:
	// - create new offer
	// - edit an existing draft offer
	// - create a copy of an existing accepted offer

	stepIndex: WizardStep = WizardStep.HEADER;
	isValid = false;
	exiting = false;
	errorInPage = false;
	readonly scrollPositionByStep = [0, 0, 0, 0, 0];
	readonly offer: AppWizardStateOffer;
	readonly ui: AppWizardStateUi;
	constructor(offer: Offer, lastSavedOffer: Offer) {
		this.offer = new AppWizardStateOffer(offer, lastSavedOffer);
		this.ui = new AppWizardStateUi();
	}
}
